<div class="flex flex-col bg-card overflow-hidden">
  <div
    class="pl-3 pr-3 py-2 border-b flex items-center"
    appAccountColorBackground
    #backgroundDirective="appAccountColorBackground"
    [colorName]="panelDef?.color"
  >
    <div class="flex items-center flex-auto" *ngIf="changeTitleMode">
      <app-form-field [fieldDef]="titleFieldDef" [model]="project" (onUpdate)="update($event)"></app-form-field>
    </div>
    <div class="flex flex-col">
      <div
        *ngIf="!changeTitleMode"
        class="font-bold text-md text-secondary uppercase tracking-wider"
        [ngClass]="backgroundDirective.isContrastLight ? 'text-white' : 'text-secondary'"
      >
        {{ panelDef.title }}
      </div>
    </div>
    <div class="ml-auto" *ngIf="canEditPanelDef">
      <button mat-icon-button type="button" *ngIf="!changeTitleMode" [matMenuTriggerFor]="listCard09Menu">
        <mat-icon
          class="icon-size-20"
          [svgIcon]="'more_vert'"
          [ngClass]="backgroundDirective.isContrastLight ? 'text-white' : 'text-secondary'"
        ></mat-icon>
      </button>
      <mat-menu #listCard09Menu="matMenu">
        <button mat-menu-item (click)="toggleChangeTitleMode()" type="button">
          <mat-icon [svgIcon]="'edit'"></mat-icon>
          Change Panel Heading
        </button>
        <button mat-menu-item [matMenuTriggerFor]="toggleLabelMenu" type="button">
          <mat-icon [svgIcon]="'color_lens'"></mat-icon>
          Heading Color
        </button>
        <mat-menu class="mailbox-details-toggle-label-menu-panel" #toggleLabelMenu="matMenu">
          <div
            mat-menu-item
            class="gap-2"
            *ngFor="let color of accountColors$ | async"
            (click)="selectHeaderColor(color.name)"
          >
            <ts-color-bubble [hexColor]="color.hex_value"></ts-color-bubble>
            {{ color.label }}
          </div>
        </mat-menu>
      </mat-menu>
      <button
        class="cancel-button"
        mat-icon-button
        type="button"
        *ngIf="changeTitleMode"
        [matTooltip]="'Cancel'"
        (click)="cancelEdits()"
      >
        <mat-icon
          [svgIcon]="'cancel'"
          [ngClass]="backgroundDirective.isContrastLight ? 'text-white' : 'text-secondary'"
        ></mat-icon>
      </button>

      <!-- Save button -->
      <button mat-icon-button *ngIf="changeTitleMode" type="submit" (click)="saveLayout()" [matTooltip]="'Save'">
        <mat-icon
          [svgIcon]="'save'"
          [ngClass]="backgroundDirective.isContrastLight ? 'text-white' : 'text-secondary'"
        ></mat-icon>
      </button>
    </div>
  </div>
  <comment-view
    [relatedToId]="project.id"
    relatedToType="Project"
    [account]="account"
    [readonly]="readonly"
  ></comment-view>
</div>
